type lineProgressProps = {
  progress: number;
  total: number;
  bgColor: string;
  backdropColor: string;
};
export default function lineProgress({
  progress,
  bgColor,
  backdropColor,
  total,
}: lineProgressProps) {
  const progress_width = Math.min(100, (progress * 100) / total);
  const progress_style = {
    width: progress_width + "%",
    backgroundColor: bgColor,
  };
  return (
    <div
      className="line-progress-bar"
      style={{ backgroundColor: backdropColor }}
    >
      <div className="line-progress-bar__value" style={progress_style}></div>
    </div>
  );
}
